import { writable } from 'svelte/store';
import { createCart, getCart } from '../shopify/cart.js';

export const cartId = writable(null);
export const cartQuantity = writable(0);

export async function initializeCart() {
	let storedId = localStorage.getItem('cart-count');

	if (!storedId) {
		const cart = await createCart();
		storedId = cart.id;
		localStorage.setItem('cart-count', storedId);
		cartQuantity.set(cart.totalQuantity || 0);
	} else {
		const cart = await getCart(storedId);
		cartQuantity.set(cart.totalQuantity || 0);
	}

	cartId.set(storedId);
}
